import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

export const ModuleAccordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `none`,
  backgroundColor: "transparent",
  boxShadow: "none",
  borderRadius: 0,

  "&:before": {
    display: "none",
  },
}));

export const ModuleAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon sx={{ fontSize: "1.5rem", color: "var(--accent)" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "transparent",
  flexDirection: "row-reverse",
  borderRadius: 0,
  padding: 0,

  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(0)",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));

export const ModuleAccordionDetails = styled(MuiAccordionDetails)(
  ({ theme }) => ({
    padding: theme.spacing(4),
    paddingTop: 0,
    paddingBottom: 0,
    border: "none",
  })
);

export const TasksAccordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `none`,
  backgroundColor: "transparent",
  boxShadow: "none",
  borderRadius: 0,

  "&:before": {
    display: "none",
  },
}));

export const TasksAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon sx={{ fontSize: "1.5rem", color: "var(--accent)" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "transparent",
  flexDirection: "row",
  borderRadius: 0,
  padding: "0 0 0 28px",
  borderTop: "1px solid #DEE4F4",

  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(0)",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

export const TasksAccordionDetails = styled(MuiAccordionDetails)(
  ({ theme }) => ({
    padding: "0 0 12px 36px",
    border: "none",
  })
);
